"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal2["default"];
  }
});
require("./Modal.scss");
var _Modal2 = _interopRequireDefault(require("react-bootstrap/lib/Modal"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Modal.js
// module id = 63
// module chunks = 25